import { render } from "./Bestyrelsen.vue?vue&type=template&id=05a439cb&ts=true"
import script from "./Bestyrelsen.vue?vue&type=script&lang=ts"
export * from "./Bestyrelsen.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__